import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'

const EmailSVG = (): React.ReactNode => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM7.78562 10.023C7.85468 10.0079 7.92641 10 8 10H22C22.0736 10 22.1453 10.0079 22.2144 10.023L15.9878 15.4713C15.4222 15.9662 14.5778 15.9662 14.0122 15.4713L7.78562 10.023ZM7.04469 10.7035C7.01564 10.7972 7 10.8968 7 11V20C7 20.5523 7.44772 21 8 21H22C22.5523 21 23 20.5523 23 20V11C23 10.8968 22.9844 10.7972 22.9553 10.7035L16.6463 16.2239C15.7037 17.0486 14.2963 17.0487 13.3537 16.2239L7.04469 10.7035Z"
      fill="white"/>
  </svg>
)

const TwitterSVG = (): React.ReactNode => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM20.6306 10.9558C21.3335 10.8209 21.9911 10.5686 22.5863 10.2218C22.3564 10.9289 21.8686 11.5229 21.233 11.8974C21.8554 11.8244 22.4489 11.6613 23 11.4207C22.5891 12.0281 22.0668 12.561 21.4657 12.9886C21.4709 13.1177 21.4733 13.2492 21.4733 13.3811C21.4733 17.3847 18.3786 22 12.7175 22C10.9801 22 9.36171 21.4983 8 20.6401C8.2403 20.6678 8.48581 20.6816 8.73412 20.6816C10.1755 20.6816 11.5032 20.1972 12.5561 19.384C11.2092 19.3609 10.0734 18.4847 9.68171 17.2817C9.86914 17.317 10.0626 17.3351 10.2608 17.3351C10.5416 17.3351 10.8139 17.2997 11.0718 17.2286C9.66288 16.9514 8.60195 15.7264 8.60195 14.2581V14.2208C9.01768 14.4465 9.49307 14.5842 9.9969 14.5988C9.17067 14.0555 8.62759 13.1281 8.62759 12.0773C8.62759 11.5229 8.77898 11.002 9.04411 10.5529C10.5628 12.388 12.8301 13.5926 15.3877 13.7191C15.3348 13.4972 15.3084 13.2665 15.3084 13.0293C15.3084 11.3564 16.6865 10 18.3846 10C19.2705 10 20.0707 10.3676 20.6306 10.9558Z"
      fill="white"/>
  </svg>
)

const LinkSVG = (): React.ReactNode => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM12.1927 14.3619C12.4534 14.04 12.4038 13.5677 12.0819 13.3071C11.7599 13.0464 11.2877 13.096 11.027 13.4179L8.64836 16.3553C7.27105 18.0562 7.53331 20.5514 9.23415 21.9287C10.935 23.3061 13.4303 23.0438 14.8076 21.3429L17.1862 18.4056C17.4469 18.0837 17.3973 17.6114 17.0753 17.3507C16.7534 17.09 16.2812 17.1397 16.0205 17.4616L13.6419 20.399C12.7859 21.456 11.2352 21.619 10.1781 20.763C9.1211 19.9071 8.95811 18.3563 9.81408 17.2993L12.1927 14.3619ZM20.1303 8.69065C19.0732 7.83469 17.5225 7.99768 16.6666 9.05471L14.2879 11.992C14.0273 12.3139 13.555 12.3636 13.2331 12.1029C12.9112 11.8422 12.8616 11.37 13.1222 11.0481L15.5008 8.11073C16.8781 6.40989 19.3734 6.14762 21.0743 7.52493C22.7751 8.90225 23.0374 11.3975 21.66 13.0984L19.2814 16.0357C19.0208 16.3576 18.5485 16.4072 18.2266 16.1466C17.9047 15.8859 17.855 15.4136 18.1157 15.0917L20.4943 12.1544C21.3503 11.0973 21.1873 9.54662 20.1303 8.69065ZM18.5616 11.6021C18.8223 11.2802 18.7727 10.8079 18.4508 10.5473C18.1289 10.2866 17.6566 10.3362 17.3959 10.6581L11.8529 17.5031C11.5923 17.825 11.6419 18.2973 11.9638 18.558C12.2857 18.8187 12.758 18.769 13.0187 18.4471L18.5616 11.6021Z"
      fill="white"/>
  </svg>
)

const openShareWindow = (event: React.SyntheticEvent<HTMLLinkElement>): void => {
  const href = event.currentTarget.href
  const w = 600
  const h = 500
  if (typeof window !== 'undefined') {
    window.popup = window.open(href, 'Dipsea', `width=${w},height=${h},left=${getX(w)},top=${getY(h)},scrollbars=1,location=0,menubar=0,resizable=0,status=0,toolbar=0`)
    window.popup.focus()
  }

  event.preventDefault()
}

function getX (w: number): number {
  if (typeof window !== 'undefined') {
    const windowLeft = window.screenLeft ? window.screenLeft : window.screenX
    return windowLeft + (window.outerWidth - w) * 0.5
  }
  return w
}

function getY (h: number): number {
  if (typeof window !== 'undefined') {
    const windowTop = window.screenTop ? window.screenTop : window.screenY
    return windowTop + (window.outerHeight - h) * 0.5
  }
  return h
}

function copyData (event: any): void {
  event.preventDefault()
  const text = (document.getElementById('linkInput') as HTMLInputElement | null)?.value
  const listener = (ev: any): void => {
    ev.clipboardData.setData('text/plain', text)
    ev.preventDefault()
  }
  document.addEventListener('copy', listener)
  document.execCommand('copy')
  document.removeEventListener('copy', listener)
}

type PropsType = {
  title: string
}
export default function SocialShareMenu ({ title }: PropsType): React.ReactNode {
  const [shareTitle, setShareTitle] = React.useState<string>('SHARE')

  let location = ''

  if (typeof window !== 'undefined') {
    location = window.location.href
  }
  return (
    <IconsContainer>
      <ShareText>{shareTitle}</ShareText>
      <IconContainer>
        <a
          onClick={(event: any): void => {
            setShareTitle('COPIED!')
            copyData(event)
            setTimeout((): void => setShareTitle('SHARE'), 1000)
          }}
        >
          <LinkSVG/>
        </a>
      </IconContainer>
      <div>
        <a
          onClick={(event: any): void => openShareWindow(event)}
          href={`http://twitter.com/share?url=${location}&text=${title}%20`}
          target="_blank" rel="noopener noreferrer">
          <IconContainer>
            <TwitterSVG/>
          </IconContainer>
        </a>
      </div>
      <div>
        <a
          href={`mailto: subject | null | undefined=Dipsea-${title}&body=%20${location}`}
          target="_blank" rel="noopener noreferrer">
          <IconContainer>
            <EmailSVG/>
          </IconContainer>
        </a>
      </div>
      <HiddenInput id="linkInput" defaultValue={location}/>
    </IconsContainer>
  )
}

const IconsContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const IconContainer = styled.div<any>`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
`
const ShareText = styled.div<any>`
  font-size: 10px;
  text-align: 'center';
  color: ${colors.sand};
  margin-top: 20px;
  margin-bottom: 16px;
`
const HiddenInput = styled.input<any>`
  visibility: hidden;
`
